import { 
    AgentApiFp,
    AgentControllerGet200Response,
    CreateAgentDto, 
    DeleteAgentDto,
    EditAgentDto,
    GetAgentDto, 
    MessageResponseDto, 
} from "@api/api";
import { apiConfig } from "@factory/query/config";
import { QueryKey } from "@factory/query/query-key.enum";

export type GetResponseAgentModel = AgentControllerGet200Response;
export type GetAgentModel = GetAgentDto;
export type MutateResponseAgentModel = MessageResponseDto;
export type CreateAgentModel = CreateAgentDto;
export type UpdateAgentModel = EditAgentDto;
export type DeleteAgentModel = DeleteAgentDto;

export const apiAgentFp = AgentApiFp(apiConfig);
export const getAgentController = apiAgentFp.agentControllerGet;
export const createAgentController = apiAgentFp.agentControllerCreate;
export const updateAgentController = apiAgentFp.agentControllerEdit;
export const deleteAgentController = apiAgentFp.agentControllerDelete;

export const QueryKeyAgent = QueryKey.Agent;